import Login from "./views/User/Login.vue";
import Register from "./views/User/Register.vue";
import FgtPwd from "./views/User/FgtPwd.vue";
import Terms from "./views/User/Terms.vue";
import Privacy from "./views/User/Privacy.vue";
import NotFound from "./views/404.vue";
import Home from "./views/Home.vue";
import Index from "./views/Index/Index.vue";
import AccountInformation from "./views/AccountManagement/AccountInformation.vue";
import ChangePassword from "./views/AccountManagement/ChangePassword.vue";
import ChangeEmailAddress from "./views/AccountManagement/ChangeEmailAddress.vue";
import ProjectManagement from "./views/ProjectManagement/ProjectManagement.vue";
import Statistics from "./views/Statistics/Statistics.vue";
import Users from "./views/Admin/Users.vue";
import Projects from "./views/Admin/Projects.vue";

let routes = [
  {
    path: "/login",
    component: Login,
    name: "login",
    hidden: true
  },
  {
    path: "/register",
    component: Register,
    name: "register",
    hidden: true
  },
  {
    path: "/forgotpassword",
    component: FgtPwd,
    name: "forgotpassword",
    hidden: true
  },
  {
    path: "/terms",
    component: Terms,
    name: "terms",
    hidden: true
  },
  {
    path: "/privacy",
    component: Privacy,
    name: "privacy",
    hidden: true
  },
  {
    path: "/404",
    component: NotFound,
    name: "",
    hidden: true
  },
  {
    path: "/",
    component: Index,
    name: "index",
    hidden: true
  },
  {
    path: "/ProjectManagement",
    component: Home,
    name: "",
    iconCls: "fa fa-address-card",
    leaf: true,
    children: [
      {
        path: "/ProjectManagement",
        component: ProjectManagement,
        name: "Project Management",
        title: "projectManage.title",
        meta: {
          requireAuth: true
        }
      }
    ]
  },
  {
    path: "/AccountManagement",
    component: Home,
    title: "accountManage.title",
    iconCls: "fa el-icon-setting",
    children: [
      {
        path: "/AccountInformation",
        component: AccountInformation,
        name: "Account Information",
        title: "accountManage.accountInfo",
        meta: {
          requireAuth: true
        }
      },
      {
        path: "/ChangePassword",
        component: ChangePassword,
        name: "Change Password",
        title: "accountManage.changePwd",
        meta: {
          requireAuth: true
        }
      },
      {
        path: "/ChangeEmailAddress",
        component: ChangeEmailAddress,
        name: "Change Email Address",
        title: "accountManage.changeEmail",
        meta: {
          requireAuth: true
        }
      }
    ]
  },
  // admin
  {
    path: "/Admin",
    component: Home,
    title: "admin.title",
    iconCls: "fa fa-id-card-o",
    adminOnly: true,
    children: [
      {
        path: "/Users",
        component: Users,
        name: "Users",
        title: "admin.users",
        meta: {
          requireAuth: true
        }
      },
      {
        path: "/Projects",
        component: Projects,
        name: "Projects",
        title: "admin.projects",
        meta: {
          requireAuth: true
        }
      }
    ]
  },
  {
    path: "/Statistics",
    component: Home,
    name: "",
    iconCls: "fa el-icon-date",
    leaf: true,
    children: [
      {
        path: "/Statistics",
        component: Statistics,
        name: "Statistics",
        title: 'stats.title',
        meta: {
          requireAuth: true,
        }
      }
    ]
  },
  {
    path: "*",
    hidden: true,
    redirect: { path: "/404" }
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js